import script from "./Homepage.vue?vue&type=script&setup=true&lang=js"
export * from "./Homepage.vue?vue&type=script&setup=true&lang=js"

import "./Homepage.vue?vue&type=style&index=0&id=4875b48e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4875b48e"]])

export default __exports__